/**
 * Web Style Import
 *
 */

import './style/dnb-pagination.scss'
